import { Filter, Search } from "lucide-react";
import { LeadSource } from "../../../crm-pages/hot-leads/types";

export const FilterBar: React.FC<{
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  selectedSource: LeadSource;
  setSelectedSource: (source: LeadSource) => void;
  sourceCounts: Record<LeadSource, number>;
}> = ({ searchQuery, setSearchQuery, selectedSource, setSelectedSource, sourceCounts }) => {
  const sources: { key: LeadSource; icon: React.ReactNode; label: string }[] = [
    { key: 'All', icon: null, label: 'All' },
    { key: 'LinkedIn', icon: '💼', label: 'LinkedIn' },
    { key: 'Website', icon: '🌐', label: 'Website' },
    { key: 'Google Ads', icon: '🔍', label: 'Google Ads' },
    { key: 'Referral', icon: '👥', label: 'Referral' },
    { key: 'Cold Outreach', icon: '✉️', label: 'Cold Outreach' }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 md:p-6 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-gray-700" />
        <h2 className="text-lg font-semibold text-gray-900">Filters</h2>
      </div>
      
      <div className="mb-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search by name, company, or position..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>

      <div>
        <p className="text-sm font-medium text-gray-700 mb-3">Filter by Lead Source:</p>
        <div className="flex flex-wrap gap-2">
          {sources.map((source) => (
            <button
              key={source.key}
              onClick={() => setSelectedSource(source.key)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
                selectedSource === source.key
                  ? 'bg-gray-900 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {source.icon && <span>{source.icon}</span>}
              <span>{source.label}</span>
              <span className={`${selectedSource === source.key ? 'text-gray-300' : 'text-gray-500'}`}>
                ({sourceCounts[source.key]})
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};